import { api } from "api/api";
import { AxiosError } from "axios";
import OperacaoProducao from "model/meta/producao/OperacaoProducao";
import Page from "model/page/Page";
import Pageable from "model/page/Pageable";
import { DataTableFilterMeta, DataTableOperatorFilterMetaData } from "primereact/datatable";
import { BaseServiceCadastros } from "service/BaseServiceCadastros";
import { getFilters } from "utils/filterUtils";

class OperacaoProducaoService implements BaseServiceCadastros<OperacaoProducao> {

    pesquisar(page: Pageable, filters?: DataTableFilterMeta | null) {
        return new Promise<Page>((resolve, reject): void => {
            let url = `/operacaoProducao/pesquisar`;
            url += getFilters(filters);

            const params = {
                page: page.page,
                size: page.size,
                sort: page.sort,
            };

            api
                .get(url, { params })
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    consultar(id: number) {
        return new Promise<OperacaoProducao>((resolve, reject): void => {
            api
                .get(`/operacaoProducao/consultar/${id}`)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    incluir(operacaoProducao: OperacaoProducao) {
        return new Promise<OperacaoProducao>((resolve, reject): void => {
            api
                .post(`/operacaoProducao/incluir`, JSON.stringify(operacaoProducao))
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    editar(operacaoProducao: OperacaoProducao) {
        return new Promise<OperacaoProducao>((resolve, reject): void => {
            api
                .put(`/operacaoProducao/editar`, JSON.stringify(operacaoProducao))
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    excluir(id: number) {
        return new Promise<void>((resolve, reject): void => {
            api
                .delete(`/operacaoProducao/excluir/${id}`)
                .then(() => resolve())
                .catch((err: AxiosError) => reject(err.response));
        });
    }

}

export default OperacaoProducaoService;